import React from 'react'
import ChatGroup from '@/features/messages/components/chat-details'
import ChatList from '@/features/messages/components/chat-list'
import { ActiveChatProvider } from '@/features/messages/context/active-chat-context'
import MessagesAccessGuard from './messages-access-guard'

function MessagesPage() {
    return (
        <MessagesAccessGuard>
            <ActiveChatProvider>
                <div className='grid lg:grid-cols-[auto_1fr] h-full overflow-hidden'>
                    <ChatList />
                    <ChatGroup />
                </div>
            </ActiveChatProvider>
        </MessagesAccessGuard>
    )
}

export default MessagesPage